<template>
  <el-select :value="value" @input="updateValue">
    <el-option
      v-for="(item, key) in list"
      :key="key"
      :label="item.Name"
      :value="item.Value"
    >
    </el-option>
  </el-select>
</template>

<script>
import myAxios from "../utils/request";
export default {
  name: "companyType",
  props: ["value"],
  created() {
    this.load();
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    load() {
      myAxios.get("/api/orderlink/getcompanytype").then(res => {
        //传递默认值
        this.$emit("transmitDefault", res[0].Value);
        this.list = res;
      });
    },
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="less"></style>
